import { MappedClass, MappedProperty } from '@h5s/util-object';

interface AstatDailyLocalTaxInfoRequestFields {
  ownerIstatId: number;
  year: number;
  month: number;
}

@MappedClass()
export class AstatDailyLocalTaxInfoRequest implements AstatDailyLocalTaxInfoRequestFields {
  @MappedProperty()
  ownerIstatId: number;

  @MappedProperty()
  year: number;

  @MappedProperty()
  month: number;

  constructor(fields?: AstatDailyLocalTaxInfoRequestFields) {
    if (!fields) return;

    Object.assign(this, fields);
  }
}
